//import 'bootstrap/dist/css/bootstrap.min.css';
import captchaImg from "../../assests/images/Captcha.JPG";
//import studentIMG from './2.png';
import { Button } from "@material-ui/core";
import { RecordVoiceOverOutlined } from "@material-ui/icons";
import React, { useState } from "react";
import { captchaValidation } from "../../Redux/Actions/webAppActions";
import ReactDOM from "react-dom";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import { connect } from "react-redux";
function Captcha(props) {
  const [captcha, setCaptcha] = useState({
    captchaValue: "",
  });
  const [captchaRefresh, setRefresh] = useState(false);
  var isVerified = false;

  const characters = "VFaWbG2XcH6dPeQ3JYf9gKhL7MjNk5wxT4AUyCDmBnEp8qrstuSvR";
  function generateString(length) {
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      let random_N = crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32; // secure random number between 0 t0 1
      result +=
        // characters.charAt(Math.floor(Math.random() * charactersLength)) + " ";
        characters.charAt(Math.floor(random_N * charactersLength)) + " ";
    }
    return result.trim();
  }
  var captcha1 = generateString(9); // Function called here and save in captcha variable
  const reset = (e) => {
    captcha1 = generateString(9);
    setRefresh(!captchaRefresh);
  };

  let handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    captcha[name] = value;
    setCaptcha(captcha);
  };
  const voice = (e) => {
    var speechSynthesis = require("speech-synthesis");
    var voicetext = "";
    for (let i = 0; i < captcha1.length; i++) {
      if (captcha1.charAt(i) == "~") {
        voicetext = voicetext + " " + "tilde" + " ";
      }
      if (captcha1.charAt(i) == "`") {
        voicetext = voicetext + " " + "back tick" + " ";
      }
      if (captcha1.charAt(i) == "!") {
        voicetext = voicetext + " " + "exclamation mark" + " ";
      }
      if (captcha1.charAt(i) == "^") {
        voicetext = voicetext + " " + "caret" + " ";
      }
      if (captcha1.charAt(i) == "(") {
        voicetext = voicetext + " " + "left parenthesis" + " ";
      }
      if (captcha1.charAt(i) == ")") {
        voicetext = voicetext + " " + "right parenthesis" + " ";
      }
      if (captcha1.charAt(i) == "-") {
        voicetext = voicetext + " " + "dash" + " ";
      }
      if (captcha1.charAt(i) == "{") {
        voicetext = voicetext + " " + "open brace" + " ";
      }
      if (captcha1.charAt(i) == "}") {
        voicetext = voicetext + " " + "close brace" + " ";
      }
      if (captcha1.charAt(i) == "[") {
        voicetext = voicetext + " " + "open bracket" + " ";
      }
      if (captcha1.charAt(i) == "]") {
        voicetext = voicetext + " " + "closed bracket" + " ";
      }
      if (captcha1.charAt(i) == ":") {
        voicetext = voicetext + " " + "colon" + " ";
      }
      if (captcha1.charAt(i) == ";") {
        voicetext = voicetext + " " + "semi colon" + " ";
      }
      if (captcha1.charAt(i) == '"') {
        voicetext = voicetext + " " + "quotation mark" + " ";
      }

      if (captcha1.charAt(i) == ">") {
        voicetext = voicetext + " " + "greater than" + " ";
      }
      if (captcha1.charAt(i) == "?") {
        voicetext = voicetext + " " + "question mark" + " ";
      }
      if (captcha1.charAt(i) == ".") {
        voicetext = voicetext + " " + "dot" + " ";
      } else {
        voicetext = voicetext + captcha1.charAt(i);
      }
    }
    setTimeout(speechSynthesis(`${captcha1}`, "en-US"), 6000);
  };
  const captchaExpire = () => {
    isVerified = true;
    console.log("executed");
  };
  const timer = setInterval(captchaExpire, 60000);
  const onSubmit = (e) => {
    var element = document.getElementById("succesBTN");
    var element2 = document.getElementById("voice");
    var element3 = document.getElementById("reset");
    var inputData = document.getElementById("inputType");
    var capt = document.getElementById("capSec");

    element.innerHTML = "Checking...";
    inputData.disabled = true;
    element.disabled = true;
    element2.disabled = true;
    element3.disabled = true;
    var compareCaptcha = "";

    for (let i = 0; i < captcha1.length; i++) {
      if (captcha1.charAt(i) != " ") {
        compareCaptcha = compareCaptcha + captcha1.charAt(i);
      }
    }

    var myFunctions = async function () {
      if (isVerified == true) {
        if (
          inputData.innerHTML === "" ||
          compareCaptcha != captcha.captchaValue
        )
          ReactDOM.render(
            <p style={{ fontSize: "12px" }}>
              Please enter the Captcha correctly!
            </p>,
            document.getElementById("exp")
          );
        if (compareCaptcha == captcha.captchaValue) {
          ReactDOM.render(
            <p>Captcha Expired!</p>,
            document.getElementById("exp")
          );
        }
        element.innerHTML = "Verify Captcha";
        inputData.disabled = false;
        element.disabled = false;
        element2.disabled = false;
        element3.disabled = false;
        inputData.value = "";

        const func = () => {
          ReactDOM.unmountComponentAtNode(document.getElementById("exp"));
          setRefresh(!captchaRefresh);
        };
        setTimeout(func, 5000);
      } else {
        if (compareCaptcha == captcha.captchaValue) {
          element.style.backgroundColor = "green";
          element.innerHTML = "Captcha Verified";
          element.disabled = true;
          element2.disabled = true;
          element3.disabled = true;
          element.style.cursor = "not-allowed";
          element2.style.cursor = "not-allowed";
          element3.style.cursor = "not-allowed";
          inputData.style.display = "none";
          element2.style.display = "none";
          element3.style.display = "none";
          capt.style.display = "none";
          clearInterval(timer);
          await props.captchaValidation(!isVerified);
        } else {
          ReactDOM.render(
            <p>Please enter the Captcha correctly!</p>,
            document.getElementById("inv")
          );
          element.style.backgroundColor = "red";
          element.style.cursor = "not-allowed";
          element.innerHTML = "Not Matched";
          element.disabled = true;
          var myFunction = function () {
            element.style.backgroundColor = "#007bff";
            element.style.cursor = "pointer";
            ReactDOM.unmountComponentAtNode(document.getElementById("inv"));
            element.innerHTML = "Verify Captcha";
            element.disabled = false;
            element2.disabled = false;
            element3.disabled = false;
            inputData.disabled = false;
            inputData.value = "";
          };
          setTimeout(myFunction, 2000);
        }
      }
    };

    setTimeout(myFunctions, 2000);
  };

  return (
    <div class="d-flex flex-column float-right-na mb-2 mt-2">
      <div class="d-flex" id="capSec">
        <div class="position-relative">
          <img src={captchaImg} className="captca-img-width" />
          <div>
            <h6 id="captcha" className="captcha-text">
              {captcha1}
            </h6>
          </div>
        </div>
        <div className="captcha-buttons">
          <Button
            variant="contained"
            startIcon={<AutorenewIcon />}
            id="reset"
            onClick={reset}
            style={{
              height: "23px",
              width: "18px",
              marginLeft: "8px",
              marginBottom: "4px",
              backgroundColor: "#d9d0d0",
            }}
          ></Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<RecordVoiceOverOutlined />}
            id="voice"
            onClick={voice}
            style={{ marginLeft: "8px", height: "23px", width: "18px" }}
          ></Button>
        </div>
      </div>

      <div style={{ marginBottom: "3px", marginTop: "5px" }}>
        <input
          type="text"
          id="inputType"
          placeholder="Enter Captcha"
          name="captchaValue"
          onChange={handleChange}
          autoComplete="off"
          spellcheck="false"
          aria-autocomplete="both"
          aria-haspopup="false"
          className="form-control"
        />
      </div>
      <div id="exp" style={{ color: "red", fontSize: "15px" }}></div>
      <div id="inv" style={{ color: "red", fontSize: "12px" }}></div>

      <div>
        {/* <Button variant='contained' color='primary' id="succesBTN" onClick={onSubmit}>Verify Captcha</Button>   */}
        <button
          class="btn-primary-continue captcha-btn-font"
          id="succesBTN"
          onClick={onSubmit}
        >
          Verify Captcha
        </button>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = {
  captchaValidation,
};

export default connect(mapStateToProps, mapDispatchToProps)(Captcha);
